/**
 * @module ol/ViewProperty
 */

/**
 * @enum {string}
 */
export default {
  CENTER: 'center',
  RESOLUTION: 'resolution',
  ROTATION: 'rotation'
};

//# sourceMappingURL=ViewProperty.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ol/ViewProperty.js
// module id = 2318
// module chunks = 0